import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-taux-logement-vacant',
    templateUrl: './taux-logement-vacant.component.html',
    styleUrls: ['./taux-logement-vacant.component.scss']
})
export class TauxLogementVacantComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }

}
